(function () {
  'use strict';

  function init(modal) {
    if (modal.__bisInitialized) return;
    modal.__bisInitialized = true;

    var productId = modal.dataset.productId;
    var productHandle = modal.dataset.productHandle;
    var productName = modal.dataset.productName;

    var configEl = modal.parentNode.querySelector('script[data-bis-config]');
    var config = configEl ? JSON.parse(configEl.textContent) : {};

    var ctaButton = document.querySelector('[data-bis-open][aria-controls="' + modal.id + '"]');
    var dialog = modal.querySelector('[data-bis-dialog]');
    var form = modal.querySelector('[data-bis-form]');
    var emailInput = modal.querySelector('[data-bis-email]');
    var variantInputs = modal.querySelectorAll('[data-bis-variant]');
    var errorEl = modal.querySelector('[data-bis-error]');
    var submitBtn = modal.querySelector('[data-bis-submit]');
    var submitText = modal.querySelector('[data-bis-submit-text]');
    var spinner = modal.querySelector('[data-bis-spinner]');
    var pickerStep = modal.querySelector('[data-bis-step="picker"]');
    var successStep = modal.querySelector('[data-bis-step="success"]');
    var successEmailEl = modal.querySelector('[data-bis-success-email]');
    var successListEl = modal.querySelector('[data-bis-success-list]');
    var closeButtons = modal.querySelectorAll('[data-bis-close]');

    var lastFocused = null;

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function setSubmitting(submitting) {
      submitBtn.disabled = submitting;
      spinner.hidden = !submitting;
      submitText.textContent = submitting ? 'Sending…' : 'Notify me';
    }

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      clearError();
      pickerStep.hidden = false;
      successStep.hidden = true;
      setTimeout(function () {
        if (typeof window.trapFocus === 'function') {
          window.trapFocus(dialog);
        } else {
          var firstFocusable = dialog.querySelector('input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
          if (firstFocusable) firstFocusable.focus();
        }
      }, 50);
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus(lastFocused);
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function handleKeydown(e) {
      if (e.key === 'Escape' && !modal.hidden) {
        e.preventDefault();
        close();
      }
    }

    function getStoreId() {
      if (config.storeId) return config.storeId;
      try {
        if (window.REZ_DATA && window.REZ_DATA.storeData && window.REZ_DATA.storeData.id) {
          return window.REZ_DATA.storeData.id;
        }
      } catch (e) {}
      return null;
    }

    function getCheckedVariants() {
      var checked = [];
      variantInputs.forEach(function (input) {
        if (input.checked) {
          checked.push({
            id: parseInt(input.value, 10),
            title: input.dataset.variantTitle
          });
        }
      });
      return checked;
    }

    function submitOne(email, variant, storeId) {
      var body = {
        email: email,
        variant_id: variant.id,
        variant_title: variant.title,
        store_id: storeId,
        product_name: config.productName || productName,
        product_id: parseInt(productId, 10),
        locale: config.locale || (window.Shopify && window.Shopify.locale) || null,
        opt_in_marketing: false
      };
      return fetch(config.endpoint || '/apps/rez/bis/product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) {
          return res.text().then(function (text) {
            throw new Error('Request failed (' + res.status + '): ' + text.slice(0, 120));
          });
        }
        return res;
      });
    }

    function showSuccess(email, variants) {
      pickerStep.hidden = true;
      successStep.hidden = false;
      successEmailEl.textContent = email;
      successListEl.innerHTML = '';
      variants.forEach(function (v) {
        var li = document.createElement('li');
        li.textContent = v.title;
        successListEl.appendChild(li);
      });
      var successClose = successStep.querySelector('[data-bis-close]');
      if (successClose) successClose.focus();
    }

    async function handleSubmit(e) {
      e.preventDefault();
      clearError();

      var email = (emailInput.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      var picked = getCheckedVariants();
      if (picked.length === 0) {
        showError('Please pick at least one sold-out option.');
        return;
      }

      var storeId = getStoreId();
      if (!storeId) {
        showError('Could not connect to back-in-stock service. Please refresh and try again.');
        return;
      }

      setSubmitting(true);
      try {
        await Promise.all(picked.map(function (v) {
          return submitOne(email, v, storeId);
        }));
        showSuccess(email, picked);
      } catch (err) {
        console.error('[back-in-stock]', err);
        showError('Sorry, something went wrong. Please try again.');
      } finally {
        setSubmitting(false);
      }
    }

    // Wire events
    if (ctaButton) ctaButton.addEventListener('click', open);
    closeButtons.forEach(function (btn) { btn.addEventListener('click', close); });
    submitBtn.addEventListener('click', handleSubmit);
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSubmit(e);
      }
    });
    document.addEventListener('keydown', handleKeydown);
  }

  function ready() {
    document.querySelectorAll('[data-bis-modal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
